import { Component, OnInit } from '@angular/core';
import {ReportComponent} from "../report/report.component";
import {Report} from "../report/report";

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrls: ['./report-list.component.css']
})
export class ReportListComponent extends ReportComponent implements OnInit {

    ngOnInit() {
		this.model = [];
        this.validar_login();
		if (this.isAdmin())
			this.get();
		else
			this.router.navigateByUrl('inicio');
  }

}



// WEBPACK FOOTER //
// ./src/app/report-list/report-list.component.ts